import { render, staticRenderFns } from "./lkuPinjamanLunas.vue?vue&type=template&id=4bc4795e&"
import script from "./lkuPinjamanLunas.vue?vue&type=script&lang=js&"
export * from "./lkuPinjamanLunas.vue?vue&type=script&lang=js&"
import style0 from "./lkuPinjamanLunas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports